module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/7-77c7b6696168e8359afef283357200f6.jpg";